import { FC } from 'react'
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';

export interface IOptions {
    label: string;
    value: string;
    disable?: boolean;
}

// Interface for the Custom Checkbox Field props.
interface ICustomSelectProps {
    name: `${string}`;
    label: string;
    options: IOptions[];
    id: string;
    required?: boolean;
    selectedValue?: string | string[];
    multiple?: boolean;
    showNoneLabel?: boolean;
    error?: boolean;
    helperText?: string;
    [x: string]: any;
}

/**
 * Re-usable custom select component.
 */
const CustomSelect: FC<ICustomSelectProps> = ({name, label, options = [], id, required = false, selectedValue, multiple, showNoneLabel = false, error, helperText, size, ...rest}) => {
    const labelId = `${name}-label`;
    const safeOptions = Array.isArray(options) ? options : [];

    return (
        <FormControl fullWidth variant="outlined" error={error} size={size}>
            <InputLabel id={labelId}>{label}</InputLabel>
            <Select
                {...rest}
                required={required}
                labelId={labelId}
                id={id}
                label={label}
                size={size}>
                {showNoneLabel && <MenuItem value="">
                    <em>None</em>
                </MenuItem>}
                {safeOptions.map(option => (
                    <MenuItem
                        value={option.value}
                        key={option.value}
                        disabled={option.disable || false}
                    >
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
            {error && helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
}

export default CustomSelect;
